export {
  eduProducts,
  lanProducts,
  indProducts,
  prodDetails
}

let eduProducts=[
  {
    image:require('@/assets/product/Educational lighting/1.jpg'),
    name:'玻尿酸密集补水面膜',
    id:1,
  },
  {
    image:require('@/assets/product/Educational lighting/2.jpg'),
    name:'美肌焕颜霜',
    id:2
  },
  {
    image:require('@/assets/product/Educational lighting/11.jpg'),
    name:'舒缓修护玻色因面霜',
    id:11
  },
  // {
  //   image:require('@/assets/product/Educational lighting/12.jpg'),
  //   name:'LED防眩光黑板灯',
  //   id:12
  // },
  {
    image:require('@/assets/product/Educational lighting/12.jpg'),
    name:'奢宠抗皱提升紧致精华霜',
    id:12
  },
];

let lanProducts=[
  {
    image:require('@/assets/product/Landscape Lighting/3.jpg'),
    name:'灵芝净颜洗面奶',
    id:3
  },
  {
    image:require('@/assets/product/Landscape Lighting/4.jpg'),
    name:'灵芝赋活靓肤乳液',
    id:4
  },
  {
    image:require('@/assets/product/Landscape Lighting/5.jpg'),
    name:'灵芝紧致修复精华液',
    id:5
  },
  // {
  //   image:require('@/assets/product/Landscape Lighting/6.jpg'),
  //   name:'泛光灯-ZY908',
  //   id:6
  // },
  // {
  //   image:require('@/assets/product/Landscape Lighting/7.jpg'),
  //   name:'泛光灯-ZY228',
  //   id:7
  // },
  // {
  //   image:require('@/assets/product/Landscape Lighting/8.jpg'),
  //   name:'泛光灯-ZY338',
  //   id:8
  // },
  {
    image:require('@/assets/product/Landscape Lighting/17.jpg'),
    name:'灵芝菌菇抗皱紧致精华水',
    id:17
  },
  // {
  //   image:require('@/assets/product/Landscape Lighting/18.jpg'),
  //   name:'泛光灯-ZQ760',
  //   id:18
  // },
];

let indProducts=[
  {
    image:require('@/assets/product/Industrial lighting/10.jpg'),
    name:'天棚灯-GC410',
    id:9
  },
  {
    image:require('@/assets/product/Industrial lighting/11.jpg'),
    name:'天棚灯-GC430',
    id:10
  },
  {
    image:require('@/assets/product/Industrial lighting/12.jpg'),
    name:'天棚灯-GC455',
    id:14
  },
  {
    image:require('@/assets/product/Industrial lighting/13.jpg'),
    name:'天棚灯-GC272',
    id:15
  },
  {
    image:require('@/assets/product/Industrial lighting/14.jpg'),
    name:'天棚灯-GC922',
    id:16
  },
];

let prodDetails = [
  {
    image:require('@/assets/product/detail/1.1.jpg'),
    id:1
  },
  {
    image:require('@/assets/product/detail/2.1.jpg'),
    id:2
  },
  {
    image:require('@/assets/product/detail/3.1.jpg'),
    id:3
  },
  {
    image:require('@/assets/product/detail/4.1.jpg'),
    id:4
  },
  {
    image:require('@/assets/product/detail/5.1.jpg'),
    id:5
  },
  {
    image:require('@/assets/product/detail/6.1.jpg'),
    id:6
  },
  {
    image:require('@/assets/product/detail/7.1.jpg'),
    id:7
  },
  {
    image:require('@/assets/product/detail/8.1.jpg'),
    id:8
  },
  {
    image:require('@/assets/product/detail/9.1.jpg'),
    id:9
  },
  {
    image:require('@/assets/product/detail/10.1.jpg'),
    id:10
  },
  {
    image:require('@/assets/product/detail/11.1.jpg'),
    id:11
  },
  {
    image:require('@/assets/product/detail/12.1.jpg'),
    id:12
  },
  {
    image:require('@/assets/product/detail/13.1.jpg'),
    id:13
  },
  {
    image:require('@/assets/product/detail/14.1.jpg'),
    id:14
  },
  {
    image:require('@/assets/product/detail/15.1.jpg'),
    id:15
  },
  {
    image:require('@/assets/product/detail/16.1.jpg'),
    id:16
  },
  {
    image:require('@/assets/product/detail/17.1.jpg'),
    id:17
  },
  {
    image:require('@/assets/product/detail/18.1.jpg'),
    id:18
  },
]
